import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../core/services/session.service';
import { RouteConstant } from '../../modules/e-sign/e-sign-routing.constant';
import { DistributionChannel } from '../models/distributionChannelType';
import { RouteNames } from '../routing/app-routing.constants';
@Injectable({
  providedIn: 'root'
})
export class ParamGuardService {

  constructor(
    private readonly router: Router,
    private readonly session: SessionService
  ) { }

  canActivate(): boolean {
    const params = this.session.getUserParams();
    const incomingdomain = window.location.hostname;
    const multipleDigitalDomain = AgAppConfigService.get<string>('digitaldomainurl')?.split(',');
    const redirectPatterns = [
      /\?lang=[a-z]{2}$/i,
      /\?lang=[a-z]{2}&forceLogin=true&AllowRegistrationProcess=false$/i,
      /\?lang=[a-z]{2}&register=true$/i
    ];
    if(redirectPatterns.some(pattern => pattern.test(this.router.url))){
      // when switching browser on mobile MSA redirects us to targetUrl defined in acr_values => ?lang=**&register=true for some reason doesn't get picked up by MSA & we get redirected to ?lang=** instead
      // this is caused due to the fact that F5 is not able to restore the authentication cookies of the use which is necessary for MSA to pass the token
      // Since F5 doesn't run in the LEAD infra currently
      void this.router.navigate([RouteNames.LoginAgnostic]);
      return false;
    }
    if (multipleDigitalDomain.includes(incomingdomain)) {
      sessionStorage.setItem('blockedContext', '1');
    }
    if (incomingdomain === AgAppConfigService.get<string>('brokerdomainurl')) {
      sessionStorage.setItem('blockedContext', '0');
    }

    if (this.session.isUserBlocked) {
      void this.router.navigate([RouteNames.blocked]);
      return false;
    }

  const isFromConnective = window.location.href.includes(RouteConstant.fromConnective);

  if (!isFromConnective && (!params || !this.distDomainCheck(params.distributionChannel, incomingdomain)
    || (params.distributionChannel !== DistributionChannel.Broker && params.distributionChannel !== DistributionChannel.AG)
    || (params.distributionChannel === DistributionChannel.AG && !params.partnercode))) {
    void this.router.navigate([RouteNames.blocked]);
    return false;
  }
    return true;
  }

  private distDomainCheck(distributionChannel: DistributionChannel, incomingdomain: string) {
    const multipleDigitalDomain = AgAppConfigService.get<string>('digitaldomainurl')?.split(',');
    if (DistributionChannel.AG === distributionChannel && multipleDigitalDomain.includes(incomingdomain)) {
      return true;
    }
    if (DistributionChannel.Broker === distributionChannel && incomingdomain === AgAppConfigService.get<string>('brokerdomainurl')) {
      return true;
    }
    return false;
  }
}
